import { RRP_SAVINGS_STORAGE_KEY } from "./constants";

// Read the checkout-displayed off-RRP savings (stashed in localStorage by
// Checkout) so it can be carried across origins via the URL. The confirmation
// page reads it for display and persists it to the order in its post-order
// background step — no blocking write before we redirect here.
var readRrpSavings = function readRrpSavings() {
  var _window$localStorage;
  var stored = typeof window !== "undefined" ? (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem(RRP_SAVINGS_STORAGE_KEY) : null;
  var amount = stored != null ? Number(stored) : NaN;
  try {
    var _window$localStorage2;
    (_window$localStorage2 = window.localStorage) === null || _window$localStorage2 === void 0 || _window$localStorage2.removeItem(RRP_SAVINGS_STORAGE_KEY);
  } catch (_unused) {
    /* ignore */
  }
  return Number.isFinite(amount) && amount > 0 ? amount : undefined;
};
export var navigateToOrderConfirmation = function navigateToOrderConfirmation(_ref) {
  var _window$localStorage3;
  var checkoutId = _ref.checkoutId,
    isGuest = _ref.isGuest,
    isDealer = _ref.isDealer,
    siteBrand = _ref.siteBrand,
    dob = _ref.dob,
    isOptIn = _ref.isOptIn;
  var timestamp = Date.now();

  // Order confirmation lives on a different origin, so localStorage from
  // here can't be read there — carry `isOptIn` through the URL (same
  // pattern as isGuest/isDealer/dob). Canonical key is `emailOptIn`,
  // written by GuestEmailOptIn / InitialPaymentSelector.
  var resolvedIsOptIn = isOptIn !== null && isOptIn !== void 0 ? isOptIn : typeof window !== "undefined" && ((_window$localStorage3 = window.localStorage) === null || _window$localStorage3 === void 0 ? void 0 : _window$localStorage3.getItem("emailOptIn")) === "true";
  var orderConfirmationUrl = "".concat(process.env.STOREFRONT_HOST, "/vino-checkout/?cartId=").concat(checkoutId, "&navigation_ts=").concat(timestamp, "&isGuest=").concat(isGuest, "&isDealer=").concat(isDealer, "&isOptIn=").concat(resolvedIsOptIn);
  var url = new URL(orderConfirmationUrl);
  url.searchParams.set("brand", siteBrand);

  // Only carry `dob` when it's a real value. A bare `&dob=${dob}` serialised
  // the string "undefined" when absent, which the confirmation page turned
  // into a junk `{ "Date of Birth": "undefined" }` metafield the HubSpot
  // upsert then rejected.
  if (dob && dob !== "undefined") {
    url.searchParams.set("dob", dob);
  }

  // Logged-in shoppers carry `sso=true` so the confirmation surface
  // can resolve their storefront session. Strict `=== false` keeps
  // the flag off for guests and undefined state.
  if (isGuest === false) {
    url.searchParams.set("sso", "true");
  }

  // The v1 order-confirmation `<Header />` reads the `returnURL` query
  // param to render the "Continue shopping" CTA (`${returnURL}/wines`)
  // and the logo link. Without it the page renders `null/wines` and
  // gives the logo `href={null}`. Re-attach the storefront host
  // (brand-aware for WM) so both surfaces resolve.
  var storefrontHost = siteBrand === "wm" ? process.env.WM_STOREFRONT_HOST || process.env.STOREFRONT_HOST : process.env.STOREFRONT_HOST;
  if (storefrontHost) {
    url.searchParams.set("returnURL", storefrontHost);
  }

  // Carry the off-RRP savings across origins; the confirmation page shows this
  // value and writes it to the order from its post-order background step.
  var rrpSavings = readRrpSavings();
  if (rrpSavings != null) {
    url.searchParams.set("rrpSavings", rrpSavings.toFixed(2));
  }
  orderConfirmationUrl = url.toString();

  // Clear cached age-verification / DOB entries before leaving checkout so
  // they don't leak into a subsequent session. Only remove what's actually
  // there to avoid firing storage events unnecessarily.
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      if (window.localStorage.getItem("ageVerificationDob") !== null) {
        window.localStorage.removeItem("ageVerificationDob");
      }
      if (window.localStorage.getItem("dob") !== null) {
        window.localStorage.removeItem("dob");
      }
    }
  } catch (_unused2) {
    /* localStorage may be unavailable (private mode, etc.) — ignore */
  }
  window.location.replace(orderConfirmationUrl);
};